import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getUserInfo, userExists, registerNewUser, getSubscriptionStatus } from '../firebase/config';
import { fecha } from '../utils/utils';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

// Hook personalizado para usar el contexto
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);         // Info del usuario
  const [premium, setPremium] = useState(false);  // Estado de suscripción
  const [loading, setLoading] = useState(true);   // Esperando respuesta de Firebase
  const [registered, setRegistered] = useState(true); // Usuario ha completado proceso
  const [planName, setPlanName] = useState(null); 

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const isRegistered = await userExists(firebaseUser.uid);

        if (isRegistered) {
          const userInfo = await getUserInfo(firebaseUser.uid);
          setUser(userInfo);

          if (userInfo.processCompleted) {
            const subs = await getSubscriptionStatus(firebaseUser.uid);
            setPremium(subs.active);
            setPlanName(subs.active && subs.planName ? subs.planName : "gratis");
            setRegistered(true);
          } else {
            setRegistered(false);
            navigate('/elige-usuario'); // Llevar a completar info, no login
          }
        } else {
          // Registro inicial del usuario en base de datos
          await registerNewUser({
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            displayName: firebaseUser.displayName,
            registerDate: fecha(),
            username: '',
            productLikes: [],
            processCompleted: false
          });

          // Crear objeto usuario con estructura esperada
          const newUserInfo = {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            displayName: firebaseUser.displayName,
            registerDate: fecha(),
            username: '',
            productLikes: [],
            processCompleted: false
          };

          setUser(newUserInfo);
          setRegistered(false);
          navigate('/elige-usuario'); // Llevar a completar info
        }
      } else {
        setUser(null);
        setPremium(false);
        setRegistered(false);
        //navigate('/login');
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ user, premium, loading, registered, planName }}>
      {children}
    </AuthContext.Provider>
 );
};
